import React from "react";

import { Placeholder } from "../page-components";

function ContactPage(props) {
  return <Placeholder title="Contact Us" {...props} />;
}

export default ContactPage;
